import React, { useEffect } from "react";
import * as echarts from "echarts/core";
import { GaugeChart } from "echarts/charts";
import { CanvasRenderer } from "echarts/renderers";

echarts.use([GaugeChart, CanvasRenderer]);

const GraficaCostos = ({ value }) => {
  useEffect(() => {
    const chartDom = document.getElementById("main");
    const myChart = echarts.init(chartDom);

    const clampedValue = value * 100; // valor en porcentaje

    // Determina el color según el valor
    const isRed = clampedValue <= 100;
    const pointerColor = isRed ? "#FF6E76" : "#7CFFB2";
    const textColor = isRed ? "#FF6E76" : "#7CFFB2";

    const option = {
      series: [
        {
          type: "gauge",
          startAngle: 180,
          endAngle: 0,
          center: ["50%", "75%"],
          radius: "90%",
          min: 0,
          max: 500,
          splitNumber: 10,
          axisLine: {
            lineStyle: {
              width: 10,
              color: [
                [0.2, "#FF6E76"], // rojo hasta 10%
                [1, "#7CFFB2"],   // verde hasta 100%
              ],
            },
          },
          pointer: {
            icon: "path://M12.8,0.7l12,40.1H0.7L12.8,0.7z",
            length: "20%",
            width: 14,
            offsetCenter: [0, "-60%"],
            itemStyle: {
              color: pointerColor,
            },
          },
          axisTick: {
            length: 8,
            lineStyle: {
              color: "auto",
              width: 2,
            },
          },
          splitLine: {
            length: 20,
            lineStyle: {
              color: "auto",
              width: 4,
            },
          },
          axisLabel: {
            color: "#464646",
            fontSize: 12,
            distance: -45,
            rotate: "tangential",
          },
          title: {
            show: true,
            offsetCenter: [0, "10%"],
            fontSize: 16,
            color: "#666",
          },
          detail: {
            fontSize: 30,
            offsetCenter: [0, "-30%"],
            valueAnimation: true,
            color: textColor,
            formatter: function () {
              return Math.round(clampedValue) + "%";
            },
          },
          data: [
            {
              value: clampedValue,
              name: "ROSI",
            },
          ],
        },
      ],
    };

    myChart.setOption(option);

    return () => {
      myChart.dispose();
    };
  }, [value]);

  return <div id="main" style={{ width: "100%", height: "300px" }} />;
};

export default GraficaCostos;
